import ReviewsSection from "@/components/ReviewsSection";
import CtaBand from "@/components/CtaBand";
import { PHONE_DISPLAY } from "@/constants/site";

const Reviews = () => (
  <>
    <section className="bg-asphalt py-20 sm:py-28 grain relative" data-testid="reviews-page-hero">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <p className="font-mono text-xs tracking-[0.3em] text-emergency uppercase">Reviews</p>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase leading-[1.02] text-white">
          5.0 stars.<br /><span className="text-outline">Earned one rescue at a time.</span>
        </h1>
        <p className="mt-6 max-w-xl text-lg text-zinc-400">
          Drivers across Tarrant County call {PHONE_DISPLAY} when it matters most. Here's what they say after.
        </p>
      </div>
    </section>
    <ReviewsSection full />
    <CtaBand />
  </>
);

export default Reviews;
